<template>
  <centralized-template>
    <!-- <div class="login-back-button">
      <a href="/">
        <svg class="bi bi-arrow-left-short" width="32" height="32" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"></path>
        </svg>
      </a>
    </div> -->
    <div class="login-wrapper d-flex justify-content-center" :style="`background-image: url('${bgPattern}');`">
      <div class="custom-container w-100">
        <div class=""><img class="login-intro-img" :src="appLogo" alt=""></div>
        <!-- Register Form -->
        <div class="register-form mt-4">
          <h2 class="mb-3 text-3xl font-weight-bold">Log in with your account
            <!-- <i class="pi pi-sign-in me-2 text-secondary text-sm"></i> -->
          </h2>
          <!-- <hr/> -->
          <div class="mb-4"><small class="text-muted">Please enter your details</small></div>
          <div class="row my-3 p-2">
            <a class="col btn m-1 btn-outline text-muted btn-light shadow d-flex align-items-center" :href="`${baseUrl}auth/google/redirect`" >
              <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_8_7041)">
                  <path d="M15.8437 8.18417C15.8437 7.64035 15.7996 7.09359 15.7055 6.55859H8.15967V9.63925H12.4808C12.3015 10.6328 11.7254 11.5117 10.8817 12.0703V14.0692H13.4597C14.9736 12.6758 15.8437 10.6181 15.8437 8.18417Z" fill="#4285F4"/>
                  <path d="M8.15974 16.0007C10.3174 16.0007 12.137 15.2923 13.4627 14.0694L10.8847 12.0705C10.1675 12.5585 9.2415 12.8348 8.16268 12.8348C6.0756 12.8348 4.30598 11.4268 3.67104 9.53369H1.01074V11.5943C2.36882 14.2958 5.13494 16.0007 8.15974 16.0007V16.0007Z" fill="#34A853"/>
                  <path d="M3.66852 9.53356C3.33341 8.53999 3.33341 7.46411 3.66852 6.47054V4.40991H1.01116C-0.123511 6.67043 -0.123511 9.33367 1.01116 11.5942L3.66852 9.53356V9.53356Z" fill="#FBBC04"/>
                  <path d="M8.15974 3.16644C9.30029 3.1488 10.4026 3.57798 11.2286 4.36578L13.5127 2.08174C12.0664 0.72367 10.1469 -0.0229773 8.15974 0.000539111C5.13494 0.000539111 2.36882 1.70548 1.01074 4.40987L3.6681 6.4705C4.3001 4.57449 6.07266 3.16644 8.15974 3.16644V3.16644Z" fill="#EA4335"/>
                </g>
                <defs>
                  <clipPath id="clip0_8_7041">
                    <rect width="16" height="16" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              <span style="margin-left: 5px;">Google</span>
            </a>
            <button 
              v-if="registrationMethod!==registrationMethods.bvn" 
              @click="changeRegistrationMethod(registrationMethods.bvn)" 
              class="col btn m-1 btn-outline text-muted btn-light shadow d-flex align-items-center">
              <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.118 4.78491V2.91825C14.118 2.17151 14.118 1.79814 13.9727 1.51292C13.8448 1.26204 13.6409 1.05807 13.39 0.930237C13.1048 0.784912 12.7314 0.784912 11.9847 0.784912H2.918C2.17126 0.784912 1.7979 0.784912 1.51268 0.930237C1.2618 1.05807 1.05782 1.26204 0.929993 1.51292C0.784668 1.79814 0.784668 2.17151 0.784668 2.91825V5.31825C0.784668 6.06498 0.784668 6.43835 0.929993 6.72357C1.05782 6.97445 1.2618 7.17842 1.51268 7.30625C1.7979 7.45158 2.17126 7.45158 2.918 7.45158H6.78467M7.45133 4.11825H7.45467M10.7847 4.11825H10.788M4.118 4.11825H4.12133M12.2847 8.78491V7.61825C12.2847 6.97391 11.7623 6.45158 11.118 6.45158C10.4737 6.45158 9.95133 6.97391 9.95133 7.61825V8.78491M7.618 4.11825C7.618 4.21029 7.54338 4.28491 7.45133 4.28491C7.35929 4.28491 7.28467 4.21029 7.28467 4.11825C7.28467 4.0262 7.35929 3.95158 7.45133 3.95158C7.54338 3.95158 7.618 4.0262 7.618 4.11825ZM10.9513 4.11825C10.9513 4.21029 10.8767 4.28491 10.7847 4.28491C10.6926 4.28491 10.618 4.21029 10.618 4.11825C10.618 4.0262 10.6926 3.95158 10.7847 3.95158C10.8767 3.95158 10.9513 4.0262 10.9513 4.11825ZM4.28467 4.11825C4.28467 4.21029 4.21005 4.28491 4.118 4.28491C4.02595 4.28491 3.95133 4.21029 3.95133 4.11825C3.95133 4.0262 4.02595 3.95158 4.118 3.95158C4.21005 3.95158 4.28467 4.0262 4.28467 4.11825ZM9.85133 11.4516H12.3847C12.758 11.4516 12.9447 11.4516 13.0873 11.3789C13.2128 11.315 13.3148 11.213 13.3787 11.0876C13.4513 10.945 13.4513 10.7583 13.4513 10.3849V9.85158C13.4513 9.47821 13.4513 9.29153 13.3787 9.14892C13.3148 9.02348 13.2128 8.92149 13.0873 8.85757C12.9447 8.78491 12.758 8.78491 12.3847 8.78491H9.85133C9.47797 8.78491 9.29128 8.78491 9.14867 8.85757C9.02323 8.92149 8.92125 9.02348 8.85733 9.14892C8.78467 9.29153 8.78467 9.47821 8.78467 9.85158V10.3849C8.78467 10.7583 8.78467 10.945 8.85733 11.0876C8.92125 11.213 9.02323 11.315 9.14867 11.3789C9.29128 11.4516 9.47797 11.4516 9.85133 11.4516Z" stroke="#98A2B3" stroke-width="1.56958" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span style="margin-left: 5px;">BVN</span>
            </button>
            <button 
              v-if="registrationMethod!==registrationMethods.nin" 
              @click="changeRegistrationMethod(registrationMethods.nin)" 
              class="col btn m-1 btn-outline text-muted btn-light shadow d-flex align-items-center">
              <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_8_7055)">
                  <path d="M2.6666 14.5449C3.06832 14.6666 3.61091 14.6666 4.53325 14.6666H11.4666C12.3889 14.6666 12.9315 14.6666 13.3332 14.5449M2.6666 14.5449C2.58047 14.5188 2.50081 14.4871 2.42527 14.4486C2.04895 14.2569 1.74299 13.9509 1.55124 13.5746C1.33325 13.1467 1.33325 12.5867 1.33325 11.4666V4.53325C1.33325 3.41315 1.33325 2.85309 1.55124 2.42527C1.74299 2.04895 2.04895 1.74299 2.42527 1.55124C2.85309 1.33325 3.41315 1.33325 4.53325 1.33325H11.4666C12.5867 1.33325 13.1467 1.33325 13.5746 1.55124C13.9509 1.74299 14.2569 2.04895 14.4486 2.42527C14.6666 2.85309 14.6666 3.41315 14.6666 4.53325V11.4666C14.6666 12.5867 14.6666 13.1467 14.4486 13.5746C14.2569 13.9509 13.9509 14.2569 13.5746 14.4486C13.499 14.4871 13.4194 14.5188 13.3332 14.5449M2.6666 14.5449C2.66682 14.0053 2.67006 13.7198 2.71782 13.4797C2.92824 12.4218 3.75517 11.5949 4.81301 11.3845C5.07061 11.3333 5.38038 11.3333 5.99992 11.3333H9.99992C10.6195 11.3333 10.9292 11.3333 11.1868 11.3845C12.2447 11.5949 13.0716 12.4218 13.282 13.4797C13.3298 13.7198 13.333 14.0053 13.3332 14.5449M10.6666 6.33325C10.6666 7.80601 9.47268 8.99992 7.99992 8.99992C6.52716 8.99992 5.33325 7.80601 5.33325 6.33325C5.33325 4.86049 6.52716 3.66659 7.99992 3.66659C9.47268 3.66659 10.6666 4.86049 10.6666 6.33325Z" stroke="#98A2B3" stroke-width="1.56958" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                  <clipPath id="clip0_8_7055">
                    <rect width="16" height="16" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              <span style="margin-left: 5px;">NIN</span>
            </button>
            <button 
              v-if="registrationMethod!==registrationMethods.email" 
              @click="changeRegistrationMethod(registrationMethods.email)" 
              class="col btn m-1 btn-outline text-muted btn-light shadow d-flex align-items-center">
              <span style="margin-left: 5px;"><i class="bi bi-envelope-fill me-2 text-secondary"></i>Email</span>
            </button>
          </div>

          <div class="position-relative my-3">
            <hr/>
            <small class="text-muted position-absolute top-50 start-50 translate-middle bg-light">Or continue with {{ registrationMethod.toLowerCase() }}</small>
          </div>
          <br/>

          <TransitionGroup name="bounce">
            <form action="#" class="was-validated" v-if="registrationMethod===registrationMethods.email">
              <div class="form-group position-relative">
                <input 
                  class="form-control px-5"
                  :class="{
                    'form-control-clicked': login.email && !v$.login.email.$invalid
                  }" type="email" 
                  v-model="v$.login.email.$model" 
                  placeholder="Email"
                >
                <div class="position-absolute form-control-prepend">
                  <i class="pi pi-user"></i>
                </div>
                <div class="input-errors text-xs text-danger mt-2" v-for="(error, index) of v$.login.email.$errors" :key="index">
                  <small class="error-msg">*{{ error.$message }}</small>
                </div>
                <div class="input-errors text-xs text-danger mt-2">
                  <!-- <div class="error-msg">{{ errors.email ? errors.email.join(",") : "" }}</div> -->
                </div>
              </div>
              <div class="form-group position-relative">
                <input 
                  class="form-control px-5"
                  :class="{
                    'form-control-clicked' : login.password && !v$.login.password.$invalid
                  }" 
                  id="psw-input" 
                  v-model="v$.login.password.$model" 
                  :type="passwordType" 
                  placeholder="Password" 
                  @keyup="checkStrength">
                <div class="position-absolute" @click="changePasswordType" id="password-visibility">
                  <i class="bi bi-eye" v-if="passwordType === 'password'"></i>
                  <i class="bi bi-eye-slash-fill" v-else></i>
                </div>
                <div class="position-absolute form-control-prepend">
                  <i class="pi pi-lock"></i>
                </div>
                <div class="input-errors text-xs text-danger mt-2" v-for="(error, index) of v$.login.password.$errors" :key="index">
                  <small class="error-msg">*{{ error.$message }}</small>
                </div>
              </div>
              <div class="login-meta-data text-right">
                <router-link class="stretched-link forgot-password d-block mt-3 mb-1" to="/forgot-password">Forgot Password?</router-link>
              </div>

              <div id="popover-password" v-if="login.password" class="text-xs">
                  <p><span id="result"></span></p>
                  <div class="progress">
                      <div id="password-strength" 
                          :class="`progress-bar ${passwordStrengthProgressBarClasses}`" 
                          role="progressbar" 
                          aria-valuenow="40" 
                          aria-valuemin="0" 
                          aria-valuemax="100" 
                          >
                      </div>
                  </div>
                  <ul class="list-unstyled">
                    <li>
                        <small class="low-upper-case text-xs">
                            <i class="bi rounded-circle px-1 bi-check2" 
                                :class="{
                                  'bg-success text-white': passwordStrength.uppercase, 
                                  'bg-light text-secondary': !passwordStrength.uppercase
                                }" aria-hidden="true"></i>
                            &nbsp;Lowercase &amp; Uppercase
                        </small>
                    </li>
                    <li>
                        <small class="one-number text-xs">
                            <i class="bi rounded-circle px-1 bi-check2" 
                                :class="{
                                  'bg-success text-white': passwordStrength.number, 
                                  'bg-light text-secondary': !passwordStrength.number
                                }" aria-hidden="true"></i>
                            &nbsp;Number (0-9)
                        </small> 
                    </li>
                    <li>
                        <small class="one-special-char text-xs">
                            <i class="bi rounded-circle px-1 bi-check2" 
                                :class="{
                                  'bg-success text-white': passwordStrength.specialChar, 
                                  'bg-light text-secondary': !passwordStrength.specialChar
                                }" aria-hidden="true"></i>
                            &nbsp;Special Character (!@#$%^&*)
                        </small>
                    </li>
                    <li>
                        <small class="eight-character text-xs">
                            <i class="bi rounded-circle px-1 bi-check2" 
                                :class="{
                                  'bg-success text-white': passwordStrength.min, 
                                  'bg-light text-secondary': !passwordStrength.min
                                }" aria-hidden="true"></i>
                            &nbsp;Atleast 8 Character
                        </small>
                    </li>
                </ul>
              </div>

              <small class="text-muted d-block mb-3">
                By signing in, you are 
                <a class="" href="#" data-bs-toggle="modal" data-bs-target="#consentModal">consenting</a> to our 
                <a class="" href="https://redge.ng/terms.html" >terms</a>
              </small>

              <app-button @click="authenticate" :title="'Sign In'" :loading="loaders().authUser" :disabled="loaders().authUser || v$.login.$invalid || passwordStrength.value < 3" ></app-button>
              <!-- 
              <hr/>
              <a class="btn m-1 btn-outline w-100 text-muted btn-light shadow" :href="`${baseUrl}auth/google/redirect`">
                <i class="bi bi-google me-2 text-danger"></i>Google
              </a> -->
            </form>

            <form  class="was-validated" v-if="registrationMethod===registrationMethods.bvn">
              <div class="form-group text-start mb-3">
                <input :class="`form-control ${ bvn ? 'form-control-clicked' : ''}`" v-model="v$.bvn.$model" type="tel" pattern="[0-9]*" required placeholder="BVN Number">
                <div class="input-errors text-xs text-danger mt-2" v-for="(error, index) of v$.bvn.$errors" :key="index">
                  <small class="error-msg">{{ error.$message }}</small>
                </div>
              </div>
              <app-button 
                @click="authenticateViaBVN" 
                :title="'Continue'" 
                :loading="loaders().identityRegistrationInit || loaders().identityAuthInit" 
                :disabled="loaders().identityRegistrationInit || v$.bvn.$invalid || loaders().identityAuthInit" 
              ></app-button>
            </form>

            <form  class="was-validated" v-if="registrationMethod===registrationMethods.nin">
              <div class="form-group text-start mb-3">
                <input :class="`form-control ${ nin ? 'form-control-clicked' : ''}`" v-model="v$.nin.$model" type="tel" pattern="[0-9]*" required placeholder="NIN Number">
                <div class="input-errors text-xs text-danger mt-2" v-for="(error, index) of v$.nin.$errors" :key="index">
                  <small class="error-msg">{{ error.$message }}</small>
                </div>
              </div>
              <app-button 
                @click="authenticateViaNIN" 
                :title="'Continue'" 
                :loading="loaders().identityRegistrationInit || loaders().identityAuthInit" 
                :disabled="loaders().identityRegistrationInit || loaders().identityAuthInit || v$.nin.$invalid" 
                ></app-button>
            </form>
          </TransitionGroup>

          <div class="input-errors text-xs text-danger mt-2" v-for="([key, error], index) of Object.entries(errors)" :key="index">
            <div class="error-msg">
              <small>{{ key }}: {{ error }}</small>
            </div>
          </div>
          <hr/>
        </div>
        <!-- Login Meta -->
        <div class="login-meta-data text-center">
          <p class="mb-0">Don't have an account? <router-link class="stretched-link text-success" to="/register">Register Now</router-link></p>
        </div>
      </div>
    </div>

    <modal title="Consent" id="consentModal">
      <p>
        You accept and consent to the terms of this Privacy Policy when you order, sign up or interact with us or any of our Services regardless of how they are accessed or used. Changes to this Privacy Policy
      </p>
      <p>
        We may modify this Privacy Policy from time to time by publishing or uploading an updated version on our website. The updated version will become effective as of the published date.
        Furthermore, if any revised version includes a substantial change in terms, Users shall be informed via email (sent to the email address specified in your account), by means of a notice on the Redge Platform.
        Controller
      </p>
      <p>
        Redge is the controller and responsible for the privacy of your personal data on the Redge app and web.
        If you have any questions about this privacy policy or our privacy practices, please contact us below –
        Customer Service Desk
      </p>
      <p>Email address: support@redge.ng</p>
    </modal>
  </centralized-template>
</template>

<script>
// @ is an alias to /src
import CentralizedTemplate from '@/components/templates/CentralizedTemplate.vue';
import AppButton from '@/components/common/form/AppButton.vue';
import { mapActions, mapGetters } from 'vuex';
import useVuelidate from '@vuelidate/core';
import { required, email, minLength } from '@vuelidate/validators';
import Modal from '@/components/common/modal/Modal.vue';
import { BASE_URL } from '../../../utils/constant.util';
import { createToaster } from "@meforma/vue-toaster";
const toaster = createToaster({ /* options */ });

export default {
  name: 'LoginPage',
  components: {
    CentralizedTemplate,
    AppButton,
    Modal
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
    const { logo } = this.appConfig() || {};
    return {
      nin: "",
      bvn: "",
      login: {},
      errors: {},
      baseUrl: BASE_URL,
      passwordType: "password",
      passwordStrength: {
        value: 0
      },
      passwordStrengthProgressBarClasses: "",
      appLogo: logo || require("../../../assets/redge.png"),
      bgPattern: require("../../../assets/images/auth/pattern.png"),
      registrationMethod: "EMAIL",
      registrationMethods: {
        email: "EMAIL",
        bvn: "BVN",
        nin: "NIN"
      }
    }
  },
  validations() {
    return {
      nin: { required, min: minLength(11) },
      bvn: { required, min: minLength(11) },
      login: {
        email: { required, email },
        password: { required, min: minLength(6) }
      }
    }
  },
  methods: {
    ...mapActions([
      "authUser",
      "identityAuthInit",
      "identityRegistrationInit"
    ]),
    ...mapGetters([
      "loaders",
      "appConfig"
    ]),
    authenticateViaBVN() {
      this.identityAuthInit({
        bvn: this.bvn
      }).then((res) => {
        const { message, code_sent } = res;
        if (code_sent) {
          this.$router.push({
            path: '/otp-confirm-page', 
            params: {bvn: this.bvn, page: "identity-auth", message},
            query: {bvn: this.bvn, page: "identity-auth", message}
          });
        }
      }).catch (err => {
        toaster.info("Please wait while we try to sign you up.")
        this.registerViaBVN()
        const { data = {}, message } = err
        this.errors = {
          ...data,
          message
        }
        this.resetError()
      })
    },
    authenticateViaNIN() {
      this.identityAuthInit({
        nin: this.nin
      }).then((res) => {
        const { message, code_sent } = res;
        if (code_sent) {
          this.$router.push({
            path: '/otp-confirm-page', 
            params: {nin: this.nin, page: "identity-auth", message},
            query: {nin: this.nin, page: "identity-auth", message}
          });
        }
      }).catch (err => { 
        toaster.info("Please wait while we try to sign you up.")
        this.registerViaNIN()
        const { data = {}, message } = err
        this.errors = {
          ...data,
          message
        }
        this.resetError()
      })
    },
    authenticate() {
      // 
      const data = {
        email: this.login.email,
        password: this.login.password
      };
      const self = this;
      this.authUser(data).then( function (res) {
        const { next, message = "" } = res;
        if (next && next === "otp") {
          self.$router.push({
            path: '/otp-confirm-page', 
            params: {email: self.login.email, page: "otp-login", message},
            query: {email: self.login.email, page: "otp-login", message}
          });
        } else {
          self.$router.push('/dashboard');
        }
      }).catch( function (err) {
        const { data = {}, message } = err
        self.errors = {...data, message};
        toaster.error(message);
      }).finally(() => {
      })
    },
    changePasswordType() {
      this.passwordType = this.passwordType === "password" ? "text" : "password"
    },
    changeRegistrationMethod(method) {
      this.registrationMethod = method
    },
    checkStrength(e) {
      const password = e.target.value
      let strength = 0;

      //If password contains both lower and uppercase characters
      if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) {
          strength += 1;
          this.passwordStrength.uppercase = true;
      } else {
          this.passwordStrength.uppercase = false;
      }
      //If it has numbers and characters
      if (password.match(/([0-9])/)) {
          strength += 1;
          this.passwordStrength.number = true;
      } else {
          this.passwordStrength.number = false;
      }
      //If it has one special character
      if (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) {
          strength += 1;
          this.passwordStrength.specialChar = true;
      } else {
        this.passwordStrength.specialChar = false;
      }
      //If password is greater than 7
      if (password.length > 7) {
          strength += 1;
          this.passwordStrength.min = true;
      } else {
          this.passwordStrength.min = false; 
      }

      // If value is less than 2
      if (strength < 2) {
          this.passwordStrengthProgressBarClasses = 'progress-bar-danger w-10'
      } else if (strength == 3) {
          this.passwordStrengthProgressBarClasses = 'progress-bar-warning w-60'
      } else if (strength == 4) {
          this.passwordStrengthProgressBarClasses = 'progress-bar-success w-100'
      }
      this.passwordStrength.value = strength;
    },
    registerViaBVN() {
      this.identityRegistrationInit({
        bvn: this.bvn
      }).then((res) => {
        const { message, code_sent } = res;
        if (code_sent) {
          this.$router.push({
            path: '/otp-confirm-page', 
            params: {bvn: this.bvn, referrer: this.referrer, page: "identity-registration", message},
            query: {bvn: this.bvn, referrer: this.referrer, page: "identity-registration", message}
          });
        }
      }).catch (err => {
        const { data = {}, message } = err
        this.errors = {
          ...data,
          message
        }
      })
    },
    registerViaNIN() {
      this.identityRegistrationInit({
        nin: this.nin
      }).then((res) => {
        const { message, code_sent } = res;
        if (code_sent) {
          this.$router.push({
            path: '/otp-confirm-page', 
            params: {nin: this.nin, referrer: this.referrer, page: "identity-registration", message},
            query: {nin: this.nin, referrer: this.referrer, page: "identity-registration", message}
          });
        }
      }).catch (err => {
        const { data = {}, message } = err
        this.errors = {
          ...data,
          message
        }
      })
    },
    resetError() {
      const self = this;
      setTimeout(function() {
        self.errors = {}
      }, 2000)
    }
  },
  watch: {
    '$store.state.auth': function(b, n) {
      if (n.access_token) {
        this.$route.path("/dashboard")
      }
    }
  },
  mounted() {
    //
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: rgba(var(--bs-success-rgb));
}

.progress {
    height: 3px !important;
}

.progress-bar-danger {
    background-color: #e90f10;
}
.progress-bar-warning{
    background-color: #ffad00;
}
.progress-bar-success{
    background-color: #02b502;
}
.w-10 {
  width: 10%;
}
.w-60 {
  width: 60%;
}
.w-100 {
  width: 100%;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
